import type { CompleteAnalysis } from '../api/types'
import { activeLanguage } from '../i18n'
import { DEFAULT_LANG } from '../i18n/languages'

/**
 * The language a STORED analysis's prose was written in (Phase 3 i18n, 3e.2).
 *
 * The API sets `analysis_locale` only on a non-English response (mtg-api
 * 3-api.1), so a blob without the marker is English by construction: every
 * writer of `saved_decks.analysis` either passes an API response through as
 * it came, or re-saves a loaded blob without dropping keys (the proof is in
 * the Phase 3 plan, "Saved-deck locale"). The client never stamps or infers
 * the marker; this only reads it.
 */
export function analysisLocaleOf(analysis: Pick<CompleteAnalysis, 'analysis_locale'> | null | undefined): string {
  return analysis?.analysis_locale || DEFAULT_LANG
}

/** True when a stored analysis is in another language than the interface. */
export function isAnalysisInOtherLanguage(
  analysis: Pick<CompleteAnalysis, 'analysis_locale'> | null | undefined,
  active: string = activeLanguage(),
): boolean {
  return analysisLocaleOf(analysis) !== active
}
